module.exports = __webpack_public_path__ + "img/maybank.9d70d8b2.png";